var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pedidos-Documento"},[_c('navigation'),_c('pedidos_documentos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }